import React from 'react'
import PropTypes from 'prop-types'
import NoteV1 from './NoteV1'
import NoteV2 from './NoteV2'

const versions = {
  1: NoteV1,
  2: NoteV2
}

/**
 * Represents an individual activity item that is non-specific
 * @param activity
 * @param length
 * @param onClick
 * @param className
 * @param style
 * @param version - version of the component (v1, v2)
 * @returns {JSX.Element}
 * @constructor
 */
function Note ({ activity, length, onClick, className, version = '1', style }) {
  const NoteComponent = versions[version] || versions['1']

  return (
    <NoteComponent activity={activity} length={length} onClick={onClick} className={className} style={style} />
  )
}

Note.propTypes = {
  activity: PropTypes.shape({
    subject: PropTypes.string,
    content: PropTypes.string,
    createdDate: PropTypes.string,
    isPinned: PropTypes.bool
  }).isRequired,
  /** Preview length */
  length: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  version: PropTypes.oneOf(['1', '2'])
}

Note.defaultProps = {
  length: 50
}

export default Note
